import React from "react";
import { Link } from "react-router-dom";

const HOME_SECTION_IDS = {
  "/download-app": "download-app",
  "/faq": "faq",
};

export function handleHomeSectionClick(event, path) {
  const sectionId = HOME_SECTION_IDS[path];
  if (!sectionId) return;

  const sectionEl = document.getElementById(sectionId);
  if (!sectionEl) return;

  event.preventDefault();
  sectionEl.scrollIntoView({ behavior: "smooth", block: "start" });

  if (window.location.pathname !== path) {
    window.history.pushState(null, "", path);
  }
}

export function HomeSectionLink({ to, className, children }) {
  return (
    <Link
      to={to}
      className={className}
      onClick={(event) => handleHomeSectionClick(event, to)}
    >
      {children}
    </Link>
  );
}
